import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const Footer = () => {
  const primaryBg = "#0d5c53";
  const darkCardBg = "#073e38";

  // Helper function to handle click and scroll to top
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Data maps extracted from your Header navigation links
  const companyLinks = [
    { name: "Home", to: "/" },
    { name: "About Us", to: "/about-us" },
    { name: "Careers Hub", to: "/careers-hub" },
    { name: "Contact Us", to: "/contact-us" },
  ];

  const managedServices = [
    { name: "Web Design and Development", to: "/web-design-and-development" },
    { name: "Mobile App Development", to: "/mobile-app-development" },
    { name: "Digital Marketing", to: "/digital-marketing" },
    { name: "Power BI Services", to: "/power-bi-services" },
    { name: "ServiceNow Development", to: "/servicenow-development" },
    { name: "Infrastructure Development", to: "/infrastructure-development" },
    { name: "Application Development", to: "/application-development" },
    { name: "Process Outsourcing", to: "/process-outsourcing" },
    { name: "Cloud Migration", to: "/cloud-migration" },
    { name: "Data Integration", to: "/data-integration" },
    { name: "Mainframe Computing", to: "/mainframes-computing" },
    { name: "Product Engineering", to: "/product-engineering" },
  ];

  const digitalTransformation = [
    { name: "Customer Experience and CPQ", to: "/customer-experience-and-cpq" },
    { name: "Supply Chain Optimization", to: "/supply-chain-optimization" },
    { name: "Big Data and Analytics", to: "/big-data-and-analytics" },
    { name: "Mobility and UX", to: "/mobility-and-ux" },
    { name: "AI and ML", to: "/ai-and-ml" },
    { name: "Robotic Process Automation", to: "/robotic-process-automation" },
    { name: "Internet of Things", to: "/internet-of-things" },
    { name: "Human Capital Management", to: "/human-capital-management" },
  ];

  const technologyLinks = [
    { name: "SAP Enterprise Systems", to: "/sap-enterprise-systems" },
    { name: "Salesforce Platforms", to: "/salesforce-platforms" },
    { name: "Oracle Cloud Solutions", to: "/oracle-cloud-and-database-solutions" },
    { name: "Microsoft Cloud Solutions", to: "/microsoft-cloud-solutions" },
    { name: "AWS Cloud Solutions", to: "/aws-cloud-solutions" },
    { name: "NetSuite Enterprise Solutions", to: "/netsuite-enterprise-solutions" },
  ];

  const industryLinks = [
    { name: "Manufacturing Solutions", to: "/manufacturing-solutions" },
    { name: "Healthcare & Biotech", to: "/healthcare-and-biotech-solutions" },
    { name: "Automotive Solutions", to: "/automotive-solutions" },
    { name: "High Tech Solutions", to: "/high-tech-solutions" },
    { name: "Aerospace", to: "/aerospace" },
    { name: "Retail and Distribution", to: "/retail-and-distribution" },
    { name: "Consumer Goods", to: "/consumer-goods" },
    { name: "Construction", to: "/construction" },
    { name: "Media and Entertainment", to: "/media-and-entertainment" },
  ];

  return (
    <footer 
      className="text-white pt-5 pb-3 position-relative" 
      style={{  
        backgroundImage: "url('./images/home.jpg')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed' // Traditional CSS Parallax Fallback
      }}
    >
      <div className="container text-white">
        
        {/* Upper Link Sections */}
        <div className="row gy-5 mb-5">
          
          {/* Column 1: Brand & Socials */}
          <div className="col-lg-3 col-md-6">
            <div className="d-flex align-items-center mb-3">
              <img src="/images/affsoft-logo.png" width={250} alt="Affsoft" className="img-fluid" style={{ maxHeight: "90px" }} />
            </div>
            <p className="text-white small pe-lg-3" style={{ lineHeight: "1.6", opacity: 0.9 }}>
              With years of experience and a team of seasoned experts, providing premium technical solutions globally.
            </p>
            
            {/* Social Icons */}
            <div className="d-flex gap-2 mt-4">
              {["facebook", "twitter-x", "dribbble", "instagram"].map((icon, idx) => (
                <a key={idx} href="#" className="btn btn-sm btn-outline-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: "36px", height: "36px" }}>
                  <i className={`bi bi-${icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Company Info & Core Tech */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-bold mb-3 small text-uppercase tracking-wider text-white">Company</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {companyLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-white text-decoration-none" onClick={handleLinkClick}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h5 className="fw-bold mt-4 mb-3 small text-uppercase tracking-wider text-white">Technology</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {technologyLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-white text-decoration-none" onClick={handleLinkClick}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Managed Services */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3 small text-uppercase tracking-wider text-white">Managed Services</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {managedServices.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-white text-decoration-none" onClick={handleLinkClick}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Digital Transformation */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-bold mb-3 small text-uppercase tracking-wider text-white">Transformation</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {digitalTransformation.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-white text-decoration-none" onClick={handleLinkClick}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 5: Industries */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-bold mb-3 small text-uppercase tracking-wider text-white">Industries</h5>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {industryLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-white text-decoration-none" onClick={handleLinkClick}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Footer Bottom / Copyright */}
        <div className="border-top border-light border-opacity-25 pt-4 text-center">
          <p className="text-white small mb-0">
            © 2004 | All rights reserved by <span className="text-white fw-semibold"> Affsoft IT Solutions Pvt. Ltd.</span>
          </p>
        </div>

      </div>

      {/* Floating Back to Top Button */}
      <button 
        className="btn btn-light rounded-circle position-absolute d-flex align-items-center justify-content-center"
        style={{ right: "30px", bottom: "30px", width: "45px", height: "45px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="bi bi-chevron-up text-dark"></i>
      </button>
    </footer>
  );
};

export default Footer;